import React, { createContext, useContext, useState, useEffect } from 'react';
import Toaster from './Toaster';
import { setToastFunction } from '../Utils/ToastUtils';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    show: false,
    message: '',
    variant: 'success',
  });

  const showToast = (message, variant = 'success') => {
    setToast({ show: true, message, variant });
    setTimeout(() => setToast({ show: false, message: '', variant: 'success' }), 5000);
  };

  // Set the toast function globally when the component mounts
  useEffect(() => {
    setToastFunction(showToast);
  }, []);

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <Toaster
        show={toast.show}
        message={toast.message}
        variant={toast.variant}
        onClose={() => setToast({ show: false, message: '', variant: 'success' })}
      />
    </ToastContext.Provider>
  );
};
